import { useLang } from "@/context/LangContext";
import { Calendar } from "lucide-react";
import { Link } from "react-router-dom";
import ShareBar from "@/components/ShareBar";
import SiteNav, { GeneralLinks } from "@/components/SiteNav";
import FunFactsTicker from "@/components/FunFactsTicker";

export default function Header({ compact = false, title }) {
  const { t, lang, setLang } = useLang();

  return (
    <>
    <header
      className="relative overflow-hidden hero-gradient text-white"
      data-testid="site-header"
    >
      <div className="hero-orb-1" />
      <div className="hero-orb-2" />
      <div className="grain-overlay" />

      <div className="relative z-10 max-w-4xl mx-auto px-6 pt-8 pb-10 sm:pt-10 sm:pb-12">
        {/* Top row: lang toggle + share */}
        <div className="flex items-center justify-between gap-3 flex-wrap">
          <Link to="/" className={`text-[11px] sm:text-xs uppercase text-indigo-200/90 hover:text-white ${lang === "ta" ? "font-tamil" : "tracking-[0.26em] font-sans-custom"}`} data-testid="header-home-link">
            {t("app_title")}
          </Link>
          <GeneralLinks />
          <div className="flex items-center gap-3 ml-auto">
            <ShareBar />
            <div className="lang-toggle" data-testid="lang-toggle">
              <button
                className={lang === "en" ? "active" : ""}
                onClick={() => setLang("en")}
                data-testid="lang-en-btn"
              >
                EN
              </button>
              <button
                className={lang === "ta" ? "active font-tamil" : "font-tamil"}
                onClick={() => setLang("ta")}
                data-testid="lang-ta-btn"
              >
                தமிழ்
              </button>
            </div>
          </div>
        </div>

        {/* Headline */}
        <h1
          className={`font-display ${compact ? "text-3xl sm:text-4xl" : "text-4xl sm:text-5xl lg:text-6xl"} mt-5 font-semibold tracking-tight`}
          data-testid="site-headline"
        >
          <Link to="/" className="hover:opacity-90">{title || t("headline")}</Link>
        </h1>

        {!compact && (
          <div className="mt-3 text-indigo-100/85 text-sm sm:text-base flex items-center gap-2 font-sans-custom">
            <Calendar size={16} className="text-emerald-300" />
            <span>{t("vote_info")}</span>
          </div>
        )}
        <SiteNav />
      </div>
    </header>
    <FunFactsTicker />
    </>
  );
}
